import './SkeletonText-c8c6465a.css';

var classes = {"SkeletonText":"prc-Skeleton-SkeletonText-o0dUS"};

export { classes as default };
